import React from 'react'
import { ReactComponent as MobileViewWarning } from "../../assets/icons/modal/MobileViewWarning.svg"
import { ReactComponent as Close } from "../../assets/icons/modal/Close.svg"

const index = ({ setShow }) => {
  const handleClose = () => setShow(false)

  return (
    <div className="ie-message-container" data-test="ie-message-container">
      <div className="ie-message">
        <MobileViewWarning />
        <p className="ie-message-text" data-test="ie-message-text">
      For the best viewing experience, try using a newer browser like{" "}
          <span className="ie-message-text-bold">Google Chrome,</span>{" "}
          <span className="ie-message-text-bold">Firefox,</span>{" "}
          <span className="ie-message-text-bold">Safari</span> or{" "}
          <span className="ie-message-text-bold">Microsoft Edge</span>.
        </p>
        <div className="ie-close-icon" data-test="ie-close-icon">
          <Close
            onClick={handleClose}
            className={"mouse-pointer"}
            aria-label={"close button"}
            tabIndex="0"
          />
        </div>
      </div>
    </div>
  )
}

export default index
